import { getApiPath } from '@/shared/api/constants';

const ORGANIZATIONS_API_NAME = 'organization';

const SHORT = '/short';
const ID_SET = '/idSet';
const TREE = '/tree';
const FACILITY = '/facility';
const WITH_FACILITIES = '/withFacilities';
const UNBLOCK = '/unblock';
const BLOCK = '/block';
export const ORGANIZATIONS_API = getApiPath(ORGANIZATIONS_API_NAME);

/* organization-search-controller */

export const ORG_BY_ID = (id: string) => ORGANIZATIONS_API + `/${id}`;
export const ORG_SHORT = ORGANIZATIONS_API + SHORT;
export const ORG_TREE = ORGANIZATIONS_API + TREE;
export const ORG_TREE_WITH_FACILITIES = ORG_TREE + WITH_FACILITIES;
export const ORG_ID_SET = ORGANIZATIONS_API + ID_SET;

/* organization-save-controller */

export const ORG_BY_ID_UNBLOCK = (id: string) => ORG_BY_ID(id) + UNBLOCK;
export const ORG_BY_ID_BLOCK = (id: string) => ORG_BY_ID(id) + BLOCK;

/* facility-save-controller */

export const ORG_FACILITY = ORGANIZATIONS_API + FACILITY;
export const ORG_FACILITY_BY_ID = (id: string) => ORG_FACILITY + `/${id}`;
